/* Maison Aurem – galerie (8 images + bouton), badge remise, carrousels infinis, panier */
(function () {
  var MAX = 8;
  function gallery() {
    document.querySelectorAll('media-gallery .media-gallery__grid').forEach(function (grid) {
      var count = grid.querySelectorAll(':scope > li').length;
      var next = grid.nextElementSibling;
      if (count <= MAX || (next && next.classList.contains('aurem-more'))) return;
      var extra = count - MAX;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'aurem-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Afficher plus d\u2019images (' + extra + ')';
      btn.addEventListener('click', function () {
        var open = grid.classList.toggle('aurem-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Afficher moins d\u2019images' : 'Afficher plus d\u2019images (' + extra + ')';
      });
      grid.insertAdjacentElement('afterend', btn);
    });
  }
  function badge() {
    var off = document.querySelector('aurem-bundle [data-qty="2"] .aurem-qty__off');
    var first = document.querySelector('media-gallery .media-gallery__grid > li:first-child');
    if (!off || !first || first.querySelector('.aurem-gal-badge')) return;
    var el = document.createElement('span');
    el.className = 'aurem-gal-badge';
    el.innerHTML = 'Paire <b>' + off.textContent.trim() + '</b> · remises sur quantité';
    first.appendChild(el);
  }
  function loops() {
    document.querySelectorAll('.aurem-same__track').forEach(function (track) {
      if (track.dataset.loop) return;
      var items = Array.prototype.slice.call(track.children);
      if (items.length < 3) return;
      track.dataset.loop = '1';
      function clone(n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a, button').forEach(function (a) { a.tabIndex = -1; });
        return c;
      }
      var before = items.map(clone), after = items.map(clone);
      before.forEach(function (c) { track.insertBefore(c, items[0]); });
      after.forEach(function (c) { track.appendChild(c); });
      var set = function () { return track.scrollWidth / 3; };
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = set();
      track.style.scrollBehavior = '';
      var t;
      function jump(d) {
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += d;
        requestAnimationFrame(function () { track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; });
      }
      function recenter() {
        var w = set();
        if (track.scrollLeft < w * 0.5) jump(w);
        else if (track.scrollLeft > w * 1.5) jump(-w);
      }
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(recenter, 140); }, { passive: true });
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(recenter, 200); });
    });
  }

  function drawer() { return document.getElementById('cart-drawer'); }
  function openDrawer() { var d = drawer(); if (d && typeof d.open === 'function') { d.open(); return true; } return false; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.aurem-action[href$="/cart"]');
    if (!a) return;
    if (openDrawer()) e.preventDefault();
  });
  var cartCount = 0;
  function refreshCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCount = cart.item_count;
        document.querySelectorAll('.aurem-cart').forEach(function (wrap) {
          var b = wrap.querySelector('.aurem-cart__count');
          if (!b && cartCount > 0) { b = document.createElement('span'); b.className = 'aurem-cart__count'; wrap.appendChild(b); }
          if (b) { b.textContent = cartCount; b.hidden = cartCount === 0; }
        });
        tier();
      }).catch(function () {});
  }
  function tier() {
    var d = drawer();
    if (!d) return;
    var host = d.querySelector('.cart-drawer__content');
    var old = d.querySelector('.aurem-tier');
    if (!host || cartCount === 0) { if (old) old.remove(); return; }
    var n = cartCount, msg, pct;
    if (n < 2) { msg = 'Ajoutez <b>1 applique</b> pour profiter de <b class="r">-15 %</b> sur la paire'; pct = 25; }
    else if (n < 4) { msg = '<b class="r">-15 %</b> appliqués ! Encore <b>' + (4 - n) + ' applique' + (4 - n > 1 ? 's' : '') + '</b> pour passer à <b class="r">-20 %</b>'; pct = n === 2 ? 50 : 75; }
    else { msg = '<b class="r">-20 %</b> appliqués sur votre commande, bravo !'; pct = 100; }
    var html = '<p class="aurem-tier__ship"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg><b>Livraison offerte</b> en France</p><p class="aurem-tier__msg">' + msg + '</p><div class="aurem-tier__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div><ul class="aurem-tier__steps" aria-hidden="true"><li>1</li><li>2 · -15 %</li><li>4 · -20 %</li></ul>';
    if (!old) { old = document.createElement('div'); old.className = 'aurem-tier'; }
    if (old.dataset.k !== String(n)) { old.innerHTML = html; old.dataset.k = String(n); }
    var title = host.querySelector('.theme-drawer__title, h2');
    if (old.parentNode !== host) { if (title && title.nextSibling) host.insertBefore(old, title.nextSibling); else host.prepend(old); }
    var summary = d.querySelector('.cart-drawer__summary');
    if (!d.querySelector('.aurem-trust')) {
      var t = document.createElement('div');
      t.className = 'aurem-trust';
      t.innerHTML = '<div class="aurem-trust__row"><span>Paiement sécurisé</span><span>Retours gratuits 45 jours</span><span>Colis protégé</span></div>';
      var tpl = document.getElementById('aurem-pay-tpl');
      if (tpl) { var icons = document.createElement('div'); icons.className = 'aurem-trust__pay'; icons.appendChild(tpl.content.cloneNode(true)); t.appendChild(icons); }
      (summary || host).appendChild(t);
    }
    if (summary) {
      var w = document.createTreeWalker(summary, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = w.nextNode())) {
        if (/exp[ée]dition est calcul[ée]e/i.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/L[’']exp[ée]dition est calcul[ée]e lors du paiement\.?/i, 'Livraison offerte en France.');
        }
      }
    }
  }
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e.promise && e.promise.then ? e.promise : Promise.resolve();
    p.then(function (res) {
      refreshCart();
      var failed = res && res.detail && res.detail.didError;
      if (e.action === 'add' && !failed) { setTimeout(openDrawer, 50); }
    }).catch(function () {});
  });
  refreshCart();

  function run() { gallery(); badge(); loops(); tier(); }
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
